import React from "react";
import { useApp } from "../context/AppContext";
import ProductCard from "../components/ProductCard";

export default function Favorites() {
  const { currentUser, getMyFavorites } = useApp();
  const favProducts = getMyFavorites();

  if (!currentUser) return null;

  return (
    <div style={s.page}>
      <h1 style={s.heading}>Mis favoritos ❤️</h1>

      {favProducts.length === 0 ? (
        <div style={s.empty}>
          <span style={{fontSize:56}}>🤍</span>
          <p style={s.emptyTitle}>No tenes favoritos todavia</p>
          <p style={s.emptyText}>Tocá el corazon ❤️ en cualquier producto para guardarlo aca.</p>
        </div>
      ) : (
        <>
          <p style={s.count}>{favProducts.length} producto{favProducts.length!==1?"s":""} guardado{favProducts.length!==1?"s":""}</p>
          <div style={s.grid}>
            {favProducts.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        </>
      )}
    </div>
  );
}

const s = {
  page:{maxWidth:1100,margin:"0 auto",padding:"32px 20px"},
  heading:{fontSize:24,fontWeight:600,marginBottom:8},
  count:{fontSize:13,color:"#888",marginBottom:16},
  empty:{textAlign:"center",padding:"80px 0",display:"flex",flexDirection:"column",alignItems:"center",gap:12},
  emptyTitle:{fontSize:18,fontWeight:500,color:"#333"},
  emptyText:{fontSize:14,color:"#888"},
  grid:{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:16},
};
